import * as types from "./actionTypes"

export function fetchCarOrder(data) {
    return {
        type: types.CAR_ORDER_FETCH_DATA,
        payload: data,
    }
}

export function fetchCarOrderFilter(data) {
    return {
        type: types.CAR_ORDER_FETCH_FILTER,
        payload: data,
    }
}

export function fetchCarOrderSuccess(data) {
    return {
        type: types.CAR_ORDER_DATA_SUCCESS,
        payload: data,
    }
}

export function fetchCarOrderFailure() {
    return {
        type: types.CAR_ORDER_DATA_FAILURE,
    }
}

export function fetchShipperTracks() {
    return {
        type: types.SHIPPER_TRACKS_FETCH_DATA,
    }
}

export function fetchShipperTracksSuccess(data) {
    return {
        type: types.SHIPPER_TRACKS_DATA_SUCCESS,
        payload: data,
    }
}

export function fetchShipperTracksFailure() {
    return {
        type: types.SHIPPER_TRACKS_DATA_FAILURE,
    }
}

export function fetchCarOrderPatterns(data) {
    return {
        type: types.CAR_ORDER_PATTERNS_FETCH_DATA,
        payload: data,
    }
}

export function fetchCarOrderPatternsSuccess(data) {
    return {
        type: types.CAR_ORDER_PATTERNS_DATA_SUCCESS,
        payload: data,
    }
}

export function fetchCarOrderPatternsFailure() {
    return {
        type: types.CAR_ORDER_PATTERNS_DATA_FAILURE,
    }
}

export function saveCarOrderQuanlity(data) {
    return {
        type: types.SAVE_CAR_ORDER_QUALITY,
        payload: data,
    }
}

export function saveCarOrderQuanlitySuccess(dataResponse) {
    return {
        type: types.SAVE_CAR_ORDER_QUALITY_SUCCESS,
        payload: dataResponse,
    }
}

export function saveCarOrderQuanlityFailure() {
    return {
        type: types.SAVE_CAR_ORDER_QUALITY_FAILURE,
    }
}
